import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { getTurnstileContainerId } from '../../constants/config'
import { AUTH_STEPS } from '../../constants/auth-steps'
import useAuth from '../../hooks/use-auth'
import { useTurnstileWidget } from '../../hooks/use-turnstile'

const noop = () => {}

export const Turnstile = styled.div`
  width: 100%;
  min-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.25em 0;
  box-sizing: border-box;
  overflow: visible;

  & > div {
    width: 100% !important;
    max-width: 100%;
  }

  iframe {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    max-width: 100%;
  }
`

export function TurnstileField ({ step = AUTH_STEPS.LOGIN_FORM, id }) {
  const containerId = id || getTurnstileContainerId(step)
  const { turnstileRuntime } = useAuth()
  const [containerEl, setContainerEl] = useState(null)

  const runtimeStep = turnstileRuntime?.step
  const runtimeMountKey = turnstileRuntime?.mountKey ?? 0
  const runtimeResetKey = turnstileRuntime?.resetKey ?? 0
  const setRuntimeToken = turnstileRuntime?.setToken || noop
  const setRuntimeWidgetId = turnstileRuntime?.setWidgetId || noop

  const containerRef = useCallback((node) => {
    setContainerEl(node)
  }, [])

  useTurnstileWidget({
    containerEl,
    enabled: Boolean(containerId) && runtimeStep === step,
    mountKey: runtimeMountKey,
    resetKey: runtimeResetKey,
    setTurnstileToken: setRuntimeToken,
    setTurnstileWidgetId: setRuntimeWidgetId,
  })

  if (!containerId) return null

  return (
    <Turnstile
      ref={containerRef}
      key={`${containerId}-${runtimeMountKey}`}
      id={containerId}
    />
  )
}

export default TurnstileField
